import React, { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Logo } from '../components/Logo';
import { LegalSectionBody } from '../components/LegalSectionBody';
import { legalDocuments, LegalDocument } from '../data/legal';
type LegalPageProps = {
  slug: LegalDocument['slug'];
};
export function LegalPage({
  slug
}: LegalPageProps) {
  const doc = legalDocuments.find(d => d.slug === slug) ?? legalDocuments[0];
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} — Superluxury`;
  }, [doc]);
  return <>
      <header className="sticky top-0 z-40 border-b border-line bg-paper" data-id="element-1495" data-mp="2n5bp0t49h1r5">
        <div className="mx-auto flex h-16 max-w-[1320px] items-center justify-between px-6 md:h-20 md:px-16" data-id="element-1496" data-mp="2i7jtzq8bkziq">
          <Link to="/" className="inline-flex items-center gap-2 text-[14px] font-light text-ink/70 transition-colors duration-150 hover:text-ink" data-id="element-1497" data-mp="1brhnria3ryvh">
            <ArrowLeftIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-1498" data-mp="1hfg4b944v3c5" />
            <span className="hidden sm:inline" data-id="element-1499" data-mp="1meatqtwlvq58">Back to Superluxury</span>
          </Link>
          <Link to="/" aria-label="Superluxury — home" data-id="element-1500" data-mp="1mbx2yx8yl03h">
            <Logo className="text-[16px] md:text-[20px]" data-id="element-1501" data-mp="18dqaxxqoxubq" />
          </Link>
          <span className="w-4 sm:w-[150px]" aria-hidden="true" data-id="element-1502" data-mp="1dd36r7zjibqg" />
        </div>
      </header>

      <main className="bg-paper px-6 pb-28 pt-16 md:px-16 md:pb-36 md:pt-24" data-id="element-1503" data-mp="yo6sgt6w42he">
        <div className="mx-auto grid max-w-[1320px] grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-1504" data-mp="13ff0plwhhhsz">
          <nav aria-label="Legal documents" className="lg:col-span-3" data-id="element-1505" data-mp="po0j9ji85oo1">
            <ul translate="no" className="flex gap-6 overflow-x-auto border-b border-line pb-4 lg:sticky lg:top-32 lg:flex-col lg:gap-3 lg:border-b-0 lg:pb-0" data-id="element-1506" data-mp="ppv3swpl3erl">
              {legalDocuments.map(d => <li key={d.slug} data-id="element-1507" data-mp="frxh4dndhq13">
                  <NavLink to={`/${d.slug}`} className={({
                isActive
              }) => `whitespace-nowrap text-[15px] transition-colors duration-150 ${isActive ? 'font-medium text-ink' : 'font-light text-ink/55 hover:text-ink'}`} data-id="element-1508" data-mp="kontoqzyy3hr">
                    {d.title}
                  </NavLink>
                </li>)}
            </ul>
          </nav>

          <article className="lg:col-span-8" data-id="element-1509" data-mp="35cp7dvkw5vg0">
            <h1 translate="no" className="font-editorial text-[44px] leading-[48px] tracking-[-0.01em] md:text-[60px] md:leading-[64px]" data-id="element-1510" data-mp="35cfi6a7o7sbd">
              {doc.title}
            </h1>
            <p className="mt-4 text-[14px] font-light text-ink/60" data-id="element-1511" data-mp="2wb7xiuy2upzr">Last updated {doc.updated}</p>
            <p translate="no" className="mt-10 max-w-[720px] text-[19px] font-light leading-[30px]" data-id="element-1512" data-mp="2rc4q53umk7om">{doc.intro}</p>

            {/* Legal text always stays in English */}
            <div translate="no" className="mt-14 max-w-[720px] divide-y divide-line border-t border-line" data-id="element-1513" data-mp="1fyamxngwouqb">
              {doc.sections.map(section => <section key={section.heading} className="py-9" data-id="element-1514" data-mp="15vxaqgxi559p">
                  <h2 className="text-[20px] font-normal leading-[28px]" data-id="element-1515" data-mp="1asdukyxo4xgz">{section.heading}</h2>
                  <LegalSectionBody section={section} data-id="element-1516" data-mp="1fs08lalbmhqu" />
                </section>)}
            </div>
          </article>
        </div>
      </main>
    </>;
}